var currentdialogue = (function () {
    function currentdialogue() {
    }
    //是否最后一句
    currentdialogue.prototype.IsLast = function () {
        return this.index == this.length;
    };
    currentdialogue.prototype.Next = function () {
        this.index++;
    };
    currentdialogue.prototype.GoFirst = function () {
        this.index = 0;
    };
    currentdialogue.prototype.UnreadCount = function (dialogue) {
        //for(var )
        var count = 0;
        for (var i = 0; i < dialogue.length; i++)
            count += dialogue[i].unread;
        return count;
    };
    return currentdialogue;
}());
export { currentdialogue };



// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/currentdialogue.ts.pre-build-optimizer.js